
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/credit-immobilier-maroc",
      function () {
        return require("private-next-pages/credit-immobilier-maroc/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/credit-immobilier-maroc"])
      });
    }
  